import { db } from './config';
import { getCurrentStaffEmail } from './auth';
import { collection, addDoc, query, where, getDocs, orderBy, limit } from 'firebase/firestore';

export const signConsent = async (clientId, type, formData) => {
  const staffEmail = getCurrentStaffEmail();
  const now = new Date();
  const expiresAt = new Date(now);
  expiresAt.setFullYear(expiresAt.getFullYear() + 1);
  
  const consent = {
    clientId,
    type,
    version: '1.0',
    signedAt: now.toISOString(),
    expiresAt: expiresAt.toISOString(),
    clientSignature: formData.clientSignature,
    staffName: formData.staffName,
    staffSignature: formData.staffSignature,
    popiaAcknowledged: true,
    treatmentRiskAcknowledged: true,
    liabilityWaiverAcknowledged: true,
    createdBy: staffEmail,
    createdAt: now.toISOString()
  };
  
  const docRef = await addDoc(collection(db, 'consents'), consent);
  return { consentId: docRef.id, ...consent };
};

export const getValidConsent = async (clientId, type) => {
  const now = new Date().toISOString();
  const q = query(
    collection(db, 'consents'),
    where('clientId', '==', clientId),
    where('type', '==', type),
    where('expiresAt', '>', now),
    orderBy('signedAt', 'desc'),
    limit(1)
  );
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  return { consentId: snapshot.docs[0].id, ...snapshot.docs[0].data() };
};

export const hasValidConsent = async (clientId, type) => {
  const consent = await getValidConsent(clientId, type);
  return consent !== null;
};

export const getConsentHistory = async (clientId, type) => {
  const q = query(
    collection(db, 'consents'),
    where('clientId', '==', clientId),
    where('type', '==', type),
    orderBy('signedAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ consentId: doc.id, ...doc.data() }));
};